import { UIHeading3 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './GenplanLayout.css';

interface IGenplanLayoutProps {
  children: React.ReactNode;
  imageDump: string;
}

export const GenplanLayout: React.FC<IGenplanLayoutProps> = ({ children, imageDump }) => {
  return (
    <div className={styles['container']}>
      <div className={styles['heading']}>
        <UIHeading3>Генплан</UIHeading3>
      </div>
      <div className={styles['layout']}>
        <div className={styles['dump-container']}>
          <img src={imageDump} className={styles['genplan-dump']} />
        </div>
        <div className={styles['genplan-container']}>{children}</div>
      </div>
    </div>
  );
};
